
import { NgModule } from '@angular/core';

import { MaterialColorPickerComponent } from './material-color-picker.component';

@NgModule({
  // declarations: [NkMaterialColorPickerComponent],
  imports: [
    
    MaterialColorPickerComponent
  ],
  // exports: [NkMaterialColorPickerComponent],
})
export class NkMaterialColorPickerModule {}
